import React from 'react'
import { BrowserRouter as Router, Route} from "react-router-dom";
import Join from   "./components/Join/Join"
import chat from   "./components/Chat/Chat"


const App = () => {


  return (
    <div className = "App">
      <Router>
        <Route exact path = "/" component= {Join} />
        <Route path = "/chat"  component = {chat}/>
      </Router>
    </div>
  )
}

export default App

